<template>
<div class="responsivenavigation">
  <div 
    @click="$emit('setSection',section)"
    :key="section.title"
    v-for="section in sections"
    class="dot"
    :class="{'active': currentSection.title == section.title}"></div>    
</div>
</template>

<script>
export default {
  props:["sections","currentSection"],
}
</script>

<style lang="scss" scoped>
.responsivenavigation{
  display: none;
}

@media (max-width: 767px) {
  .responsivenavigation{
    display: flex;
    width: 45%;
    margin: 0 auto;
    justify-content: space-between;
    margin-top: 25px;
  }  
  .responsivenavigation .dot{
    width: 12px;
    height: 12px;
    background: #dedee0;
    border-radius: 50%;
    z-index: 999999999;
  }

  .responsivenavigation .dot.active{
    background-color: #337e95;
  }
}
</style>